import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import FinishLater from '../FinishLater/FinishLater';
import SideNavStepProgressBar from '../../common/SideNavStepProgressBar/SideNavStepProgressBar';
import cloraLogo from '../../../../assets/images/Logo_Gray.svg';
import './OnboardingHeader.scss';
function OnboardingHeader(_ref) {
  var onboardType = _ref.onboardType,
    name = _ref.name,
    finishViewLink = _ref.finishViewLink,
    claimInfoUrl = _ref.claimInfoUrl,
    profileUrl = _ref.profileUrl,
    csrfToken = _ref.csrfToken,
    step = _ref.step,
    state = _ref.state,
    userId = _ref.userId,
    updateMenu = _ref.updateMenu,
    handleMenuUpdate = _ref.handleMenuUpdate,
    handleMenuClick = _ref.handleMenuClick,
    showFinishPage = _ref.showFinishPage;
  return /*#__PURE__*/React.createElement("div", {
    className: "onboarding-header-nav"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "navbar navbar-expand-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "navbar-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, !showFinishPage && /*#__PURE__*/React.createElement("button", {
    className: "navbar-toggler me-3",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#clora-onboarding-navbar",
    "aria-controls": "navbarText",
    "aria-expanded": "false",
    "aria-label": "Toggle navigation"
  }, /*#__PURE__*/React.createElement("span", {
    className: "navbar-toggler-icon"
  })), /*#__PURE__*/React.createElement("a", {
    className: "navbar-brand",
    href: "#"
  }, /*#__PURE__*/React.createElement("span", {
    className: "navbar-brand"
  }, /*#__PURE__*/React.createElement("img", {
    src: cloraLogo,
    alt: "clora logo",
    className: "brand-img",
    height: 30,
    width: 75
  })))), !showFinishPage && step !== 0 && /*#__PURE__*/React.createElement(FinishLater, {
    claimInfoUrl: claimInfoUrl,
    userId: userId,
    onboardType: onboardType,
    name: name,
    step: step,
    resourceLink: finishViewLink || '/opportunities',
    profileUrl: profileUrl,
    csrfToken: csrfToken
  })), /*#__PURE__*/React.createElement("div", {
    className: "collapse navbar-collapse",
    id: "clora-onboarding-navbar"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "navbar-nav me-auto mb-2 mb-lg-0"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(SideNavStepProgressBar, {
    step: step,
    state: state,
    userId: userId,
    updateMenu: updateMenu,
    handleMenuUpdate: handleMenuUpdate,
    handleMenuClick: handleMenuClick
  })))))));
}
OnboardingHeader.propTypes = {
  onboardType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  finishViewLink: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
  state: PropTypes.number.isRequired,
  userId: PropTypes.string.isRequired,
  handleMenuClick: PropTypes.func.isRequired,
  updateMenu: PropTypes.bool.isRequired,
  handleMenuUpdate: PropTypes.func.isRequired,
  claimInfoUrl: PropTypes.func.isRequired,
  profileUrl: PropTypes.string.isRequired,
  showFinishPage: PropTypes.bool.isRequired
};
export default OnboardingHeader;